import React from 'react';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useRefreshActionItem } from 'Hooks/useRefreshEvent';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import PropTypes from 'prop-types';
import TasksDialog from './TasksDialog';
import List from './ActionItemList';

const useStyles = buildUseStyles('UpNextTaskingActionItems', () => ({
  root: {
    textAlign: 'center',
  },
}));

const ActionItems = ({ dialogLabel }) => {
  const classes = useStyles();
  const { clientDashboardResource } = useDashboardContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [clientTodoCollection, setClientTodoCollection] = React.useState(null);

  const replaceClientActionItem = (resp) => {
    const [resource] = resp;
    clientTodoCollection.resources().updateItem(resource);
    setClientTodoCollection(clientTodoCollection);
  };

  const refreshActionItems = React.useCallback(async () => {
    try {
      const resp = await clientDashboardResource.relationship(fr.relationships.tasks.name).link('related').get();
      setClientTodoCollection(resp);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  }, [clientDashboardResource, setClientTodoCollection, displayErrorMessage]);

  useComponentDidMount(() => {
    return refreshActionItems();
  });

  useRefreshActionItem(() => {
    return refreshActionItems();
  }, [refreshActionItems]);

  return (
    <div className={classes.root}>
      <List
        actionItemCollection={clientTodoCollection}
        refreshActionItems={refreshActionItems}
        replaceActionItem={replaceClientActionItem}
        background="transparent"
      />
      {clientTodoCollection ? (
        <TasksDialog
          listCollection={clientTodoCollection}
          refreshListCollection={refreshActionItems}
          dialogLabel={dialogLabel}
        />
      ) : null}
    </div>
  );
};

ActionItems.defaultProps = {
  dialogLabel: null,
};

ActionItems.propTypes = {
  dialogLabel: PropTypes.string,
};

export default ActionItems;
